import {
  DegreeLeadFormContextData,
  DegreeLeadFormContextVariant,
  DegreeLeadFormContextTestResult,
  UseDegreeLeadFormContext,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "degreesLeadFormContextTest";

const useDegreeLeadFormContext: UseDegreeLeadFormContext = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: DegreeLeadFormContextData;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as DegreeLeadFormContextTestResult;
  }

  // Determine the variant based on the returned data
  const variant: DegreeLeadFormContextVariant = value?.data?.leadFormContext
    ?.showContext
    ? "showContext"
    : "control";

  // Extract data for the experiment
  const { data } = value;

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant,
    data,
  };
};

export default useDegreeLeadFormContext;
